"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isArrayOfArrays = void 0;
var isArrayOfArrays = function isArrayOfArrays(arr) {
  return arr.every(function (v) {
    return Array.isArray(v);
  });
};
exports.isArrayOfArrays = isArrayOfArrays;